import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { AuthProvider } from "./state/AuthContext";
import { ConfigProvider } from "./state/ConfigContext";
import { ToastProvider } from "./state/ToastContext";

import "@fontsource-variable/inter";
import "@fontsource-variable/plus-jakarta-sans";
import "@fontsource-variable/noto-sans-sc";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/components.css";
import "./styles/portal.css";

const App = () => (
  <StrictMode>
    <BrowserRouter>
      <ConfigProvider>
        <AuthProvider>
          <ToastProvider>
            <AppRoutes />
          </ToastProvider>
        </AuthProvider>
      </ConfigProvider>
    </BrowserRouter>
  </StrictMode>
);

const container = document.getElementById("root");
if (!container) throw new Error("Root container missing");

/**
 * Hydrate when the server prerendered this page, mount fresh otherwise.
 *
 * Public pages ship as prerendered HTML so crawlers and slow connections
 * get readable content immediately; private pages have nothing to
 * prerender and are mounted normally.
 */
if (container.hasChildNodes()) {
  hydrateRoot(container, <App />);
} else {
  createRoot(container).render(<App />);
}
